module.exports = "/images/mz.svg?5aa3661c553aea4dc749127500f85939";